import React, { FC } from 'react';
import { useAdfoxContext } from 'shared/context/AdfoxContext';
import { useBannerEnrichments } from 'shared/hooks/useBannerEnrichments';

import { TgbStretch } from './TgbStretch';
import { TTgbStretchContext } from '../../bannerTemplateTypes';
import { getTgbStretchProps } from './utils/getTgbStretchProps';

type TTgbStretchContainerProps = {
  context: TTgbStretchContext;
};

export const TgbStretchContainer: FC<TTgbStretchContainerProps> = ({ context }) => {
  const bannerEnrichment = useBannerEnrichments(context);
  const { sizes } = useAdfoxContext();

  return <TgbStretch {...getTgbStretchProps({ context, sizes, bannerEnrichment })} />;
};
